// features/pitch/viewPitchSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPitches, addPitch as addPitchAPI, deletePitch as deletePitchAPI } from "../services/api"; // adjust based on your path

export const fetchPitches = createAsyncThunk("pitch/fetchPitches", async () => {
  const res = await getAllPitches();

  // Check if pitch data exists
  if (res && res.data && res.data.pitch) {
    // Mapping to extract only required fields for each pitch
    const mappedPitches = res.data.pitch.map(pitch => ({
      _id: pitch._id, // Use the actual _id from API
      name: pitch.name, // Pitch name
      sportName: pitch.sport?.name, // Sport name
      facilityName: pitch.facility?.name, // Facility name
      maxPlayers: pitch.maxPlayers, // Max players
    }));

    // Log the mapped data to check
    console.log('Mapped Pitches:', mappedPitches);

    return mappedPitches;
  } else {
    // Log an error if pitch data is not available
    console.error('Pitch data not found in the response');
    return [];
  }
});

export const addPitch = createAsyncThunk(
  "pitch/addPitch",
  async (pitchData) => {
    const response = await addPitchAPI(pitchData);
    return response.data;
  }
);

export const deletePitch = createAsyncThunk(
  "pitches/deletePitch",
  async (pitchId, { rejectWithValue }) => {
    try {
      const response = await deletePitchAPI(pitchId);
      if (response.data.status === false) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Failed to delete pitch" });
    }
  }
);

const viewPitchSlice = createSlice({
  name: "pitch",
  initialState: {
    pitches: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPitches.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPitches.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pitches = action.payload; // Store the simplified data
      })
      .addCase(fetchPitches.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addPitch.fulfilled, (state, action) => {
        state.pitches.push(action.payload);
      })
      .addCase(deletePitch.fulfilled, (state, action) => {
        state.pitches = state.pitches.filter(pitch => pitch._id !== action.payload);
      });
  },
});

export const selectAllPitches = (state) => state.pitch?.pitches || [];
export const selectPitchStatus = (state) => state.pitch?.status || "idle";
export const selectPitchError = (state) => state.pitch?.error || null;

export default viewPitchSlice.reducer;
